module.exports = __webpack_public_path__ + "img/Player.0f84ea13.svg";